import React, { Fragment, useLayoutEffect } from 'react';
import { Login, SignUp, Contact, ThankYou, Restore, RestoreEnter } from '.';
import { Header } from 'components';
import css from './short.scss';
import { useParams } from 'helpers';

export function ShortWrap(props) {
  useLayoutEffect(props.setReady, []);

  const params = useParams();

  const routes = [
    [/login|upgrade/, Login],
    [/sign-up|go-premium/, SignUp],
    [/contact\/$/, Contact],
    [/contact\/thank-you/, ThankYou],
    [/restore\/?$/, Restore],
    [/restore\/.+/, RestoreEnter],
  ];

  return (
    <Fragment>
      <div className={css.hero}>
        <Header.Compensate />
        <div className={css.container}>
          { routes.map(( [key, Route] ) =>
            <Route key={key} status={props.status} active={key.test(props.location.pathname)} {...params} />
          ) }
        </div>
      </div>
    </Fragment>
  );
}
